/*
 * OB TIE DYE | FAMILY ADD-ON (Oct 20 2026)
 * ------------------------------------------------------------
 * Loaded from snippets/ob-guide-morelinks.liquid as a normal (not deferred) script, so it runs
 * before the guide's deferred scripts. ob-guide-v3.js and the sheet are untouched.
 *
 * 1. Family tag cleanup: the guide's Family Friendly filter only counts the exact tags Family, Kids,
 *    Family Friendly or All Ages. Rows tagged "Kids + Family", "Preschool", "Toddler" etc. were left out.
 *    Those rows get a "Family" tag added in the browser as the feed loads (the sheet is not changed).
 * 2. This Week at a Glance: the Festivals column becomes a Family column (up to 3 kid-friendly
 *    events in the next 7 days for the area on screen, OB Picks first, then soonest).
 *    "See all" turns on the Family Friendly filter. If there are no family events that week,
 *    the Festivals column stays.
 * 3. Dates: event pages open on all upcoming events unless the link names a date; the When pills
 *    get a "This Week" option, and tapping an active pill turns it off again.
 * 4. Weekly regulars: a switch row (Happy Hours, Trivia, Open Mics, Live Music, Games + Karaoke,
 *    Everything weekly) stays above the results while any weekly view is on.
 * 5. Jump buttons (glance See all, Weekly Regulars tiles, switch row, Family See all) start a fresh
 *    view instead of stacking on old filters. Area and dates are kept.
 * 6. Empty results list each active filter as a one-tap Remove button.
 * 7. Phones: This Week at a Glance gets a row of category tabs (tap to jump, highlights as you swipe).
 * 8. One area picker in the hero: the city switcher above the headline is hidden; the search bar
 *    picker (areas + other guides) stays, without its repeated SoCal list.
 * 9. Hero: upcoming OB Tie Dye markets replace the weather box on wide screens (strip below is hidden
 *    there); smaller screens keep the strip. No upcoming booths = weather stays.
 * 10. Happy hours + weekly pages: no This Week at a Glance (markets still show, like every event page).
 * 11. Draft previews only: guide links point at the real pages so happy hours pages open correctly.
 *
 * Undo: remove the ob-guide-family.js script tag in snippets/ob-guide-morelinks.liquid.
 */
(function(){
  'use strict';
  if(window.__obFamily)return;window.__obFamily=true;

  /* ---------- 1. family tags ---------- */
  var EXACT=/^\s*(family|families|kids|family[\s-]*friendly|kid[\s-]*friendly|all[\s-]*ages)\s*$/i;
  var LOOSE=/famil|\bkids?\b|all[\s-]*ages|children|\btoddlers?\b|preschool|storytime|\btots?\b/i;
  function isKid(o){var t=o&&o.tags;if(!t)return false;if(!Array.isArray(t))t=String(t).split(',');return t.some(function(x){return LOOSE.test(String(x))})}
  function fixTags(list){
    if(!list||!list.length)return list;
    for(var i=0;i<list.length;i++){
      var o=list[i],r=o&&o.__obRaw?o.__obRaw:o;if(!r||!r.tags)continue;
      var t=Array.isArray(r.tags)?r.tags:String(r.tags).split(',');
      if(t.some(function(x){return EXACT.test(String(x))}))continue;
      if(t.some(function(x){return LOOSE.test(String(x))})){t=t.slice();t.push('Family');r.tags=t;if(o!==r)o.tags=t}
    }
    return list;
  }
  try{
    var cur=window.OB_GUIDE_ITEMS;
    Object.defineProperty(window,'OB_GUIDE_ITEMS',{configurable:true,enumerable:true,
      get:function(){return cur},set:function(v){cur=fixTags(v)}});
    if(cur)fixTags(cur);
  }catch(_){}

  /* ---------- 3. Dates: start on everything upcoming, plus a This Week pill ----------
   * The guide opened on Today unless the link named a date. Now an event page with no date,
   * search or OB Picks in its link opens on Any date (all upcoming). Oct 21 2026: happy hours + weekly
   * pages do too (they used to open on Today). The When pills gain "This Week", and tapping a pill that is
   * already on turns it off (back to everything). */
  var WEEKLY_PAGE=/happy-hours|weekly/.test(location.pathname);
  try{
    var u0=new URL(location.href),p0=u0.searchParams;
    if(/^\/pages\/events/.test(u0.pathname)&&!['when','from','to','guide','q','search','picks','day'].some(function(k){return p0.has(k)})){
      p0.set('when','all');history.replaceState(history.state,'',u0.pathname+'?'+p0.toString()+u0.hash);
    }
  }catch(_){}
  function setWhen(v){var r=document.querySelector('#obg input[name="obg-when"][value="'+v+'"]');if(r){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}}
  function syncPills(){
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}if(!st)return;
    Array.prototype.forEach.call(document.querySelectorAll('#obg button[data-obl-when]'),function(b){
      var k=b.getAttribute('data-obl-when');if(k==='pick')return;
      b.setAttribute('aria-pressed',st.when===k?'true':'false');
    });
  }
  function addWeekPill(){
    if(WEEKLY_PAGE)return;
    var quick=document.querySelector('#obg .obl-quick');if(!quick||quick.querySelector('[data-obl-when="week"]'))return;
    var ref=quick.querySelector('[data-obl-when="weekend"]'),src=quick.querySelector('button[data-obl-when="today"]');if(!src)return;
    var b=src.cloneNode(true);b.setAttribute('data-obl-when','week');b.setAttribute('aria-pressed','false');
    var lbl=b.querySelector('span')||b;lbl.textContent='This Week';
    quick.insertBefore(b,ref||null);
    syncPills();
  }
  /* city pages (San Diego etc.) show day cards instead of pills: add a This Week card there too */
  function weekLabel(){
    var t=dayKey(Date.now()),e=addDays(t,6),a=kd(t),b=kd(e);
    return a.getUTCMonth()===b.getUTCMonth()?MO[a.getUTCMonth()]+' '+a.getUTCDate()+'–'+b.getUTCDate():MO[a.getUTCMonth()]+' '+a.getUTCDate()+' – '+MO[b.getUTCMonth()]+' '+b.getUTCDate();
  }
  function addWeekCard(){
    if(WEEKLY_PAGE)return;
    var row=document.querySelector('#obg .obg-dates');if(!row)return;
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}
    var card=row.querySelector('[data-obwkcard]');
    if(!card){
      var ref=row.querySelector('[data-date="weekend"]');
      card=document.createElement('button');card.type='button';card.className='obg-dcard';card.setAttribute('data-obwkcard','');
      card.innerHTML='<b>This Week</b><span>'+esc(weekLabel())+'</span>';
      row.insertBefore(card,ref||row.lastElementChild);
    }
    var on=!!st&&st.when==='week';if(card.getAttribute('aria-pressed')!==String(on))card.setAttribute('aria-pressed',on?'true':'false');
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('#obg [data-obwkcard]');if(!b)return;
    e.preventDefault();e.stopImmediatePropagation();
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}
    setWhen(st&&st.when==='week'?'all':'week');
  },true);
  function bindPills(root){
    root.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('button[data-obl-when]');if(!b)return;
      var k=b.getAttribute('data-obl-when');if(k==='pick')return;
      if(b.getAttribute('aria-pressed')==='true'){
        e.preventDefault();e.stopImmediatePropagation();setWhen('all');
        Array.prototype.forEach.call(root.querySelectorAll('[data-obl-when]'),function(x){x.setAttribute('aria-pressed','false')});
      }
    },true);
  }

  /* ---------- 4. Weekly regulars switcher ----------
   * Tapping a Weekly Regulars tile (Happy Hours etc.) filtered the list and the tiles disappeared,
   * so there was no way to hop to trivia or open mics. While a weekly view is on (or on a happy
   * hours + weekly page) a row of switch buttons sits above the results. They reuse the guide's own
   * data-wk handling; this only clears the previous search or category first so they don't stack. */
  var WK=[['happy','Happy Hours'],['trivia','Trivia'],['openmic','Open Mics'],['music','Live Music'],['games','Games + Karaoke'],['other','Everything weekly']];
  function wkActive(st){
    if(!st)return'';var q=String(st.q||'').toLowerCase().trim(),c=st.cats||[];
    if(q==='trivia')return'trivia';if(q==='open mic')return'openmic';if(q)return'';
    if(c.length===1&&c[0]==='happy')return'happy';
    if(st.weekly==='only'){if(c.length===1&&c[0]==='games')return'games';if(c.length===1&&c[0]==='music')return'music';return'other'}
    return'';
  }
  function wkRow(){
    var root=document.getElementById('obg');if(!root)return;
    var head=root.querySelector('.obg-results-head');if(!head)return;
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}if(!st)return;
    var act=wkActive(st),show=!!act||(WEEKLY_PAGE&&!st.q&&!(st.cats||[]).length);
    var row=root.querySelector('.obn-wk-switch');
    if(!row){
      if(!show)return;
      row=document.createElement('div');row.className='obg-rchips obn-wk-switch';row.setAttribute('role','group');row.setAttribute('aria-label','Weekly regulars');
      row.innerHTML=WK.map(function(w){return '<button type="button" class="obg-chip obg-rchip" data-wk="'+w[0]+'" data-obwk aria-pressed="false"><span>'+esc(w[1])+'</span></button>'}).join('');
      head.parentNode.insertBefore(row,head);
    }else if(row.nextElementSibling!==head&&head.parentNode){head.parentNode.insertBefore(row,head)}
    row.hidden=!show;
    Array.prototype.forEach.call(row.querySelectorAll('[data-wk]'),function(b){var on=b.getAttribute('data-wk')===(act||(WEEKLY_PAGE?'other':''));if(b.getAttribute('aria-pressed')!==String(on))b.setAttribute('aria-pressed',on?'true':'false')});
  }
  /* ---------- 5. Jump buttons start fresh ----------
   * Filters used to stack: Games + Karaoke left "Weekly stuff only" on, then Family's See all added
   * Family Friendly on top, and nothing matched. Every jump button (This Week at a Glance See all,
   * Weekly Regulars tiles, the weekly switch row, Family See all) now clears search, categories,
   * weekly mode, Good for flags, OB Picks and Open now first. Area and dates stay. The quick chips
   * and sidebar still combine filters on purpose. */
  function fire(el){el.dispatchEvent(new Event('change',{bubbles:true}))}
  function freshView(){
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}if(!st)return;
    var root=document.getElementById('obg');if(!root)return;
    if(st.q){var clr=root.querySelector('.obg-search-clear');if(clr)clr.click()}
    var all=root.querySelector('input[name="obg-allcats"]');
    if(all&&(st.cats||[]).length){all.checked=false;fire(all)}
    Array.prototype.forEach.call(root.querySelectorAll('input[name="obg-good"]'),function(x){if(x.checked){x.checked=false;fire(x)}});
    ['obgPicks','obgOpen'].forEach(function(id){var x=document.getElementById(id);if(x&&x.checked){x.checked=false;fire(x)}});
    try{st=window.OB_GUIDE_V3.state()}catch(_){}
    if(st&&st.weekly){var w=root.querySelector('#obgActive [data-remove="weekly"]');if(w)w.click()}
  }
  window.OB_GUIDE_FRESH=freshView;
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    var b=e.target.closest('#obg [data-obwk], #obg .obg-wkreg [data-wk], #obg [data-gl-all]');if(!b)return;
    freshView();
    /* the guide's own handler on #obg takes it from here */
  },true);

  /* ---------- 6. Empty results: one-tap ways out ----------
   * When nothing matches, the empty message lists each active filter as a "Remove" button
   * (same as tapping its x above the list), so people can back out one step instead of starting over. */
  function emptyHelp(){
    var root=document.getElementById('obg');if(!root)return;
    var em=root.querySelector('#obgList .obg-empty');if(!em||em.querySelector('.obn-undo'))return;
    var pills=root.querySelectorAll('#obgActive [data-remove]');if(!pills.length)return;
    var box=document.createElement('div');box.className='obn-undo obg-empty-acts';
    box.innerHTML='<span style="width:100%;font-size:13px;opacity:.75">Try removing one:</span>'+Array.prototype.map.call(pills,function(p){
      return '<button type="button" class="obg-btn" data-remove="'+esc(p.getAttribute('data-remove'))+'">'+esc(p.textContent.trim())+' ×</button>';
    }).join('');
    var acts=em.querySelector('.obg-empty-acts');em.insertBefore(box,acts||null);
  }

  /* ---------- 7. Glance tabs on phones ----------
   * On phones This Week at a Glance is a sideways swipe row with no scrollbar, so only the first
   * category (Live Music) shows and nothing hints at the rest. A row of category tabs sits above it
   * on screens under 900px: tap one to jump to it; the one in view is highlighted as you swipe. */
  var GL_CSS='#obg .obn-gl-tabs{display:none}'+
    '@media (max-width:899px){#obg .obn-gl-tabs{display:flex;flex-wrap:nowrap;gap:6px;overflow-x:auto;padding:12px 12px 2px;scrollbar-width:none;-webkit-overflow-scrolling:touch}'+
    '#obg .obn-gl-tabs::-webkit-scrollbar{display:none}#obg .obn-gl-tabs .obg-chip{flex:0 0 auto;height:32px;padding:0 12px;font-size:13px;white-space:nowrap}}';
  function glanceTabs(){
    var card=document.querySelector('#obg .obg-glance .obg-gl-card');if(!card)return;
    var cols=card.querySelector('.obg-gl-cols');if(!cols)return;
    if(!document.getElementById('obn-gl-css')){var st=document.createElement('style');st.id='obn-gl-css';st.textContent=GL_CSS;document.head.appendChild(st)}
    var list=Array.prototype.slice.call(cols.children).filter(function(c){return c.classList.contains('obg-gl-col')});
    var names=list.map(function(c){var h=c.querySelector('h3');return h?h.textContent.trim():''});
    var sig=names.join('|'),tabs=card.querySelector('.obn-gl-tabs');
    if(!tabs||tabs.getAttribute('data-sig')!==sig){
      if(!tabs){tabs=document.createElement('div');tabs.className='obn-gl-tabs';tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label','This week by category')}
      tabs.setAttribute('data-sig',sig);
      tabs.innerHTML=names.map(function(n,i){return '<button type="button" class="obg-chip" data-gltab="'+i+'" aria-pressed="'+(i===0?'true':'false')+'">'+esc(n)+'</button>'}).join('');
      if(tabs.nextElementSibling!==cols)card.insertBefore(tabs,cols);
    }
    if(!cols.__obnTabs){
      cols.__obnTabs=true;
      var raf=0;
      cols.addEventListener('scroll',function(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;markTab(card)})},{passive:true});
    }
  }
  function markTab(card){
    var cols=card.querySelector('.obg-gl-cols'),tabs=card.querySelector('.obn-gl-tabs');if(!cols||!tabs)return;
    var list=Array.prototype.slice.call(cols.children).filter(function(c){return c.classList.contains('obg-gl-col')});
    var best=0,bd=1e9,left=cols.scrollLeft;
    list.forEach(function(c,i){var d=Math.abs((c.offsetLeft-list[0].offsetLeft)-left);if(d<bd){bd=d;best=i}});
    if(left+cols.clientWidth>=cols.scrollWidth-4)best=list.length-1;
    Array.prototype.forEach.call(tabs.querySelectorAll('[data-gltab]'),function(b,i){b.setAttribute('aria-pressed',i===best?'true':'false')});
    var on=tabs.querySelector('[aria-pressed="true"]');
    if(on&&(on.offsetLeft<tabs.scrollLeft||on.offsetLeft+on.offsetWidth>tabs.scrollLeft+tabs.clientWidth))tabs.scrollTo({left:Math.max(0,on.offsetLeft-12),behavior:'smooth'});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('#obg [data-gltab]');if(!b)return;
    var card=b.closest('.obg-gl-card'),cols=card&&card.querySelector('.obg-gl-cols');if(!cols)return;
    var list=Array.prototype.slice.call(cols.children).filter(function(c){return c.classList.contains('obg-gl-col')});
    var c=list[+b.getAttribute('data-gltab')];if(!c)return;
    cols.scrollTo({left:c.offsetLeft-list[0].offsetLeft,behavior:'smooth'});
    Array.prototype.forEach.call(card.querySelectorAll('[data-gltab]'),function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
  });

  /* ---------- 8. One area picker in the hero ----------
   * The hero had two dropdowns: the city switcher above the headline (changes guide page) and the
   * Area picker in the search bar (filters the list and also jumps to other guides). They could
   * disagree ("All of SoCal" vs "San Diego"). The search bar picker already does both jobs, so the
   * city switcher is hidden, and the picker's "SoCal destinations" group (a repeat of the SoCal
   * areas listed above it) is removed so each place shows once. */
  var ONE_CSS='#obg .obg-hero .obg-city{display:none!important}';
  function onePicker(){
    if(!document.getElementById('obn-one-css')){var st=document.createElement('style');st.id='obn-one-css';st.textContent=ONE_CSS;document.head.appendChild(st)}
    var sel=document.getElementById('obgHeroRegion');if(!sel)return;
    Array.prototype.forEach.call(sel.querySelectorAll('optgroup[data-obn="other"]'),function(g){
      if(/^SoCal destinations$/i.test(g.label)&&sel.querySelector('optgroup[data-obn="mine"]')&&/SoCal/i.test(sel.querySelector('optgroup[data-obn="mine"]').label)){var v=sel.value;g.parentNode.removeChild(g);if(sel.value!==v)sel.value=v}
    });
  }

  /* ---------- 9. OB Tie Dye markets in the hero instead of weather ----------
   * When we have upcoming booths, the weather box in the hero is hidden. On wide screens (1000px+)
   * a matching card in that same spot lists the next markets (up to 3) and the separate
   * "Upcoming OB Tie Dye Markets" strip below the hero is hidden. Smaller screens keep the strip
   * right under the hero. Pages with no upcoming booths (destination guides) keep the weather. */
  var MK_CSS='#obg.obn-mk-hero .obg-hero-wx{display:none!important}'+
    '#obg .obn-hero-mk{display:none}'+
    '@media (min-width:1000px){#obg.obn-mk-hero .obg-markets{display:none!important}'+
    '#obg .obn-hero-mk{display:block;position:absolute;top:50%;right:28px;transform:translateY(-50%);width:270px;padding:14px 16px 12px;border-radius:16px;background:rgba(9,22,30,.55);border:1px solid rgba(255,255,255,.18);box-shadow:0 10px 30px rgba(0,0,0,.25);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#fff;z-index:2}'+
    '#obg .obn-hero-mk p.obn-mk-title{margin:0 0 6px;font:700 11.5px/1.3 Inter,sans-serif;letter-spacing:.12em;text-transform:uppercase;color:rgb(240,160,112)}'+
    '#obg .obn-hero-mk a.obn-mk-row{display:block;padding:9px 0;border-top:1px solid rgba(255,255,255,.14);color:#fff;text-decoration:none}'+
    '#obg .obn-hero-mk a.obn-mk-row:first-of-type{border-top:0}'+
    '#obg .obn-hero-mk a.obn-mk-row:hover b{text-decoration:underline;text-underline-offset:2px}'+
    '#obg .obn-hero-mk small{display:block;font:600 12px/1.3 Inter,sans-serif;color:rgb(240,160,112)}'+
    '#obg .obn-hero-mk b{display:block;font:600 14.5px/1.3 Inter,sans-serif;margin:2px 0 1px}'+
    '#obg .obn-hero-mk span{display:block;font:400 12.5px/1.3 Inter,sans-serif;opacity:.8}'+
    '#obg .obn-hero-mk a.obn-mk-shop{display:inline-block;margin-top:6px;font:600 12.5px Inter,sans-serif;color:#fff;text-decoration:underline;text-underline-offset:2px;opacity:.9}}';
  function heroMarkets(){
    var root=document.getElementById('obg');if(!root)return;
    var sec=document.getElementById('obgMarkets'),inner=root.querySelector('.obg-hero .obg-hero-inner');if(!inner)return;
    var rows=sec&&!sec.hidden?Array.prototype.slice.call(sec.querySelectorAll('.obg-mkt')).slice(0,3):[];
    var box=inner.querySelector('.obn-hero-mk');
    if(!rows.length){root.classList.remove('obn-mk-hero');if(box)box.parentNode.removeChild(box);return}
    if(!document.getElementById('obn-mk-css')){var st=document.createElement('style');st.id='obn-mk-css';st.textContent=MK_CSS;document.head.appendChild(st)}
    var html='<p class="obn-mk-title">Come find us</p>'+rows.map(function(r){
      var q=function(c){var e=r.querySelector(c);return e?e.textContent.trim():''};
      var href=r.getAttribute('href')||'';
      return '<a class="obn-mk-row"'+(href?' href="'+esc(href)+'" target="_blank" rel="noopener"':'')+'><small>'+esc(q('.obg-mkt-date'))+'</small><b>'+esc(q('.obg-mkt-title'))+'</b><span>'+esc(q('.obg-mkt-meta'))+'</span></a>';
    }).join('')+'<a class="obn-mk-shop" href="/collections/all-products-1" data-shop="hero_markets">Can’t make it? Shop online →</a>';
    if(!box){box=document.createElement('div');box.className='obn-hero-mk';box.setAttribute('aria-label','Upcoming OB Tie Dye markets');inner.appendChild(box)}
    if(box.getAttribute('data-html')!==html){box.innerHTML=html;box.setAttribute('data-html',html)}
    root.classList.add('obn-mk-hero');
  }

  /* ---------- 10. Happy hours + weekly pages stay focused ----------
   * These pages are about the weekly regulars, so This Week at a Glance is hidden there.
   * Oct 21 2026: OB Tie Dye markets stay on every event page, these included.
   * Oct 21 2026: OB Picks hidden here too, and the "What's on, any day of the week" box moves up
   * to sit right under the top bar, with the full guide (all upcoming) below it. */
  if(WEEKLY_PAGE){
    try{var wst=document.createElement('style');wst.id='obn-weekly-css';
      wst.textContent='#obg .obg-glance,#obg #obgPicksFeat{display:none!important}#obg .obl-tail.obn-top{margin-top:8px;margin-bottom:8px}';
      (document.head||document.documentElement).appendChild(wst)}catch(_){}
  }
  function weeklyTop(){
    if(!WEEKLY_PAGE)return;
    var root=document.getElementById('obg');if(!root)return;
    var tail=root.querySelector('.obl-tail'),bar=root.querySelector('.obl-discover:not(.obl-tail)');
    if(!tail||!bar||!bar.parentNode)return;
    if(bar.nextElementSibling!==tail){bar.parentNode.insertBefore(tail,bar.nextSibling)}
    if(!tail.classList.contains('obn-top'))tail.classList.add('obn-top');
  }


  /* ---------- 12. Glance cards (Oct 21 2026) ----------
   * Each This Week at a Glance category becomes its own card: a photo of the soonest event (from the
   * feed's image; a tinted icon tile when there's none), its day/time (plus OB PICK), title and venue,
   * then the next ones as short "Fri · Title" lines. Cards sit in a row (3 on desktop, 2 on tablets,
   * one and a peek on phones) and the category tabs show at every size. "See all" becomes an arrow.
   * Undo: remove glanceCards() from soon() below. */
  var CARD_CSS='#obg .obg-glance .obg-gl-card{background:transparent;border:0;border-radius:0;overflow:visible}'+
    '#obg .obg-glance .obn-gl-tabs{display:none}'+
    '#obg .obg-glance .obg-sec-head{display:flex;align-items:flex-end;justify-content:space-between;gap:12px}#obg .obg-glance [data-obn-cal]{white-space:nowrap}'+
    '#obg .obg-glance .obg-gl-cols{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));grid-auto-flow:row;grid-auto-columns:auto;gap:14px;overflow:visible;padding:2px 1px 6px}'+
    '#obg .obg-glance .obg-gl-cols::-webkit-scrollbar{display:none}'+
    '#obg .obg-glance .obg-gl-col,#obg .obg-glance .obg-gl-col:first-child{scroll-snap-align:start;display:flex;flex-direction:column;background:#fff;border:1px solid var(--line);border-radius:16px;padding:13px 13px 9px}'+
    '#obg .obg-glance .obg-gl-colhead{align-items:center;margin-bottom:12px}'+
    '#obg .obg-glance .obg-gl-col h3{font-size:12.5px;letter-spacing:.06em;color:var(--ink);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'+
    '#obg .obg-glance .obg-gl-colhead .obg-sec-all{font-size:0;line-height:1;padding:4px;color:var(--ink)}'+
    '#obg .obg-glance .obg-gl-colhead .obg-sec-all:after{content:"\\2197";font-size:18px}'+
    '#obg .obn-gl-img{display:block;aspect-ratio:16/9;border-radius:12px;overflow:hidden;background:var(--or-bg,#fbeee5);margin:0 0 10px}'+
    '#obg .obn-gl-img img{width:100%;height:100%;object-fit:cover;display:block}'+
    '#obg .obn-gl-ph{display:flex;align-items:center;justify-content:center}#obg .obn-gl-ph .obg-i,#obg .obn-gl-ph svg{width:46px;height:46px;color:var(--or);opacity:.75}'+
    '#obg .obg-glance .obg-gl-item.obn-feat{border-top:0;padding:0 0 11px;margin:0 0 4px;border-bottom:1px solid var(--line2);gap:4px}'+
    '#obg .obn-feat .obg-gl-when{font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--muted)}'+
    '#obg .obn-feat .obg-gl-when{font-size:11px}'+
    '#obg .obn-feat .obg-gl-title{font-size:16px;line-height:1.25}'+
    '#obg .obn-feat .obg-gl-venue{font-size:13px}'+
    '#obg .obg-glance .obg-gl-item.obn-mini{border-top:0;padding:5px 0;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:13.5px;color:var(--ink)}'+
    '#obg .obn-mini b{font-weight:700}#obg a.obn-mini:hover .obn-mini-t{text-decoration:underline;text-underline-offset:2px}'+
    '@media (max-width:1099px){#obg .obg-glance .obg-gl-cols{grid-template-columns:repeat(3,minmax(0,1fr))}}'+
    '@media (max-width:699px){#obg .obg-glance .obn-gl-tabs{display:flex;flex-wrap:nowrap;gap:6px;overflow-x:auto;padding:0 0 12px;scrollbar-width:none}'+
    '#obg .obg-glance .obg-gl-cols{grid-template-columns:none;grid-auto-flow:column;grid-auto-columns:86%;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none}#obg .obn-feat .obg-gl-title{font-size:17px}}';
  var IMG_MAP=null,IMG_N=-1;
  function normT(x){return String(x||'').toLowerCase().replace(/[★★]/g,'').replace(/\s+/g,' ').trim()}
  function imgFor(title){
    var it=window.OB_GUIDE_ITEMS||[];
    if(!IMG_MAP||IMG_N!==it.length){IMG_MAP={};IMG_N=it.length;for(var i=0;i<it.length;i++){var o=it[i];if(o&&o.image&&/^https?:/.test(o.image)){var k=normT(o.title);if(!IMG_MAP[k])IMG_MAP[k]=o.image}}}
    /* the glance's own moon notes aren't sheet events, so they get the default full moon photo here (Oct 21 2026) */
    return IMG_MAP[normT(title)]||(/\bfull moon\b/i.test(String(title||''))?'https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-events-full-moon.jpg':'');
  }
  var DAYS={monday:'Mon',tuesday:'Tue',wednesday:'Wed',thursday:'Thu',friday:'Fri',saturday:'Sat',sunday:'Sun'};
  function shortWhen(w){var d=String(w||'').split('·')[0].trim();return DAYS[d.toLowerCase()]||d}
  function glanceCards(){
    var cols=document.querySelectorAll('#obg .obg-glance .obg-gl-col');if(!cols.length)return;
    /* "Full calendar →" in the section header switches the guide below to its calendar view */
    var head=document.querySelector('#obg .obg-glance .obg-sec-head');
    if(head&&!head.querySelector('[data-obn-cal]')){var cb=document.createElement('button');cb.type='button';cb.className='obg-sec-all';cb.setAttribute('data-obn-cal','');cb.textContent='Full calendar →';head.appendChild(cb)}
    if(!document.getElementById('obn-card-css')){var st=document.createElement('style');st.id='obn-card-css';st.textContent=CARD_CSS;document.head.appendChild(st)}
    Array.prototype.forEach.call(cols,function(col){
      var items=Array.prototype.slice.call(col.querySelectorAll('.obg-gl-item'));if(!items.length)return;
      /* Oct 21 2026: an OB Pick always takes the featured (photo) spot; the rest stay soonest first */
      if(!col.querySelector('.obn-feat')){
        var pk=items.filter(function(a){return a.querySelector('.obg-r4-star')})[0];
        if(pk&&pk!==items[0]){items[0].parentNode.insertBefore(pk,items[0]);items.splice(items.indexOf(pk),1);items.unshift(pk)}
      }
      var f=items[0];
      if(!f.classList.contains('obn-feat')){
        var tEl=f.querySelector('.obg-gl-title'),wEl=f.querySelector('.obg-gl-when');
        var star=tEl&&tEl.querySelector('.obg-r4-star');if(star){star.parentNode.removeChild(star);tEl.textContent=tEl.textContent.trim()}
        if(star&&wEl)wEl.textContent=wEl.textContent+' · OB Pick';
        var src=tEl?imgFor(tEl.textContent):'',box=document.createElement('span');
        box.className='obn-gl-img';box.setAttribute('aria-hidden','true');
        var ic=col.querySelector('h3 svg');
        function ph(){box.classList.add('obn-gl-ph');box.innerHTML=ic?ic.outerHTML:''}
        if(src){var im=document.createElement('img');im.loading='lazy';im.alt='';im.src=src;im.onerror=ph;box.appendChild(im)}else ph();
        f.insertBefore(box,f.firstChild);f.classList.add('obn-feat');
      }
      items.slice(1).forEach(function(a){
        if(a.classList.contains('obn-mini'))return;
        var w=a.querySelector('.obg-gl-when'),t=a.querySelector('.obg-gl-title');
        var title=t?t.textContent.replace(/[★★]/g,'').trim():'';
        a.innerHTML='<b>'+esc(shortWhen(w?w.textContent:''))+'</b> · <span class="obn-mini-t">'+esc(title)+'</span>';
        a.classList.add('obn-mini');
      });
    });
  }

  /* ---------- 11. Draft previews: real page links ----------
   * While previewing an unpublished theme, ob-guide-landing.js rewrites guide links to
   * /pages/events?view=<page>. Pages without their own template (the happy hours pages) then open
   * the wrong page. Shopify keeps the preview going on normal links, so those links are pointed
   * back at /pages/<page>. The live site never rewrites links, so nothing changes there. */
  function fixPreviewLinks(){
    var role=window.Shopify&&Shopify.theme&&Shopify.theme.role;if(!role||role==='main')return;
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/pages/events?view="]'),function(a){
      try{var u=new URL(a.getAttribute('href'),location.origin),v=u.searchParams.get('view');if(!v||!/^events-/.test(v))return;
        u.searchParams.delete('view');u.pathname='/pages/'+v;a.setAttribute('href',u.pathname+(u.search||'')+u.hash)}catch(_){}
    });
  }

  /* ---------- 2. Family column in This Week at a Glance ---------- */
  var ICON='<svg class="obg-i" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M8.5 14a4 4 0 0 0 7 0M9 9.5h.01M15 9.5h.01"/></svg>';
  var WD=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],MO=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function tz(){return window.OB_GUIDE_TZ||'America/Los_Angeles'}
  var fDay,fTime;
  function dayKey(ms){fDay=fDay||new Intl.DateTimeFormat('en-CA',{timeZone:tz(),year:'numeric',month:'2-digit',day:'2-digit'});return fDay.format(new Date(ms))}
  function timeLabel(ms){fTime=fTime||new Intl.DateTimeFormat('en-US',{timeZone:tz(),hour:'numeric',minute:'2-digit'});return fTime.format(new Date(ms)).replace(':00 ',' ').replace(' AM','am').replace(' PM','pm')}
  function addDays(k,n){var a=k.split('-').map(Number);return new Date(Date.UTC(a[0],a[1]-1,a[2]+n,12)).toISOString().slice(0,10)}
  function kd(k){var a=k.split('-').map(Number);return new Date(Date.UTC(a[0],a[1]-1,a[2],12))}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function truthy(v){return v===true||/^(yes|true|1)$/i.test(String(v||'').trim())}
  function tracked(u){
    try{var x=new URL(u,location.href);if(!/^https?:$/.test(x.protocol))return u;var h=x.hostname.toLowerCase();
      if(h===location.hostname||/obtiedye\.com$/.test(h))return u;var has=false;x.searchParams.forEach(function(v,k){if(/^utm_/i.test(k))has=true});if(has)return u;
      x.searchParams.set('utm_source','obtiedye.com');x.searchParams.set('utm_medium','referral');x.searchParams.set('utm_campaign','socal_event_guide');x.searchParams.set('utm_content','glance_family');return x.toString()}catch(_){return u}
  }
  function picks(test){
    test=test||isKid;
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}
    var region=st?st.region:'all',now=Date.now(),t=dayKey(now),end=addDays(t,6),seen={},out=[];
    var list=window.OB_GUIDE_ITEMS||[];
    for(var i=0;i<list.length;i++){
      var o=list[i],r=o&&o.__obRaw?o.__obRaw:o;if(!r||!r.title||!r.start)continue;
      var s=Date.parse(r.start);if(isNaN(s))continue;var e=r.end?Date.parse(r.end):s+6*36e5;if(isNaN(e))e=s+6*36e5;
      if(e<now)continue;var sd=dayKey(s),ed=dayKey(e-1000);if(sd>end||ed<t)continue;
      if(o.weekly||r.weekly)continue;
      if(/^low$/i.test(String(o.priority||r.priority||'').trim()))continue;
      if(region&&region!=='all'&&String(r.region||'').trim()!==region)continue;
      if(!test(r))continue;
      var k=String(r.title).toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();if(seen[k])continue;seen[k]=1;
      out.push({r:r,s:s,e:e,sd:sd,ed:ed,pick:truthy(r.starred),hi:/^high$/i.test(String(o.priority||r.priority||'').trim())});
    }
    out.sort(function(a,b){return (b.pick-a.pick)||(b.hi-a.hi)||((a.sd<t)-(b.sd<t))||(a.s-b.s)});
    /* top 3 chosen by OB Pick, then High priority, then soonest; shown soonest first like the other columns */
    return {list:out.slice(0,3).sort(function(a,b){return a.s-b.s}),today:t};
  }
  function when(x,t){
    if(x.sd<t)return 'Thru '+MO[kd(x.ed).getUTCMonth()]+' '+kd(x.ed).getUTCDate();
    var d=x.sd===t?'Today':x.sd===addDays(t,1)?'Tomorrow':WD[kd(x.sd).getUTCDay()];
    return x.r.all_day?d:d+' · '+timeLabel(x.s);
  }
  function build(){
    var root=document.getElementById('obg');if(!root)return;
    var cols=root.querySelector('.obg-glance .obg-gl-cols');if(!cols||cols.querySelector('[data-obfam]'))return;
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}
    var memo=(st?st.region:'')+'|'+dayKey(Date.now());
    if(build.empty===memo)return;
    var p=picks();if(!p.list.length){build.empty=memo;return}
    build.empty='';
    var col=document.createElement('div');col.className='obg-gl-col';col.setAttribute('data-obfam','');
    col.innerHTML='<div class="obg-gl-colhead"><h3>'+ICON+'Family</h3><button type="button" class="obg-sec-all" data-obfam-all aria-label="See all family friendly events">See all →</button></div>'+
      p.list.map(function(x){
        var r=x.r,tag=r.url?'a':'div',attrs=r.url?' href="'+esc(tracked(r.url))+'" target="_blank" rel="noopener"':'';
        return '<'+tag+' class="obg-gl-item"'+attrs+'><span class="obg-gl-when">'+esc(when(x,p.today))+'</span><span class="obg-gl-title">'+(x.pick?'<span class="obg-r4-star" role="img" aria-label="OB Pick">★</span> ':'')+esc(r.title)+'</span><span class="obg-gl-venue">'+esc(r.place||r.hood||'')+'</span></'+tag+'>';
      }).join('');
    var fest=cols.querySelector('[data-gl-all="fest"]'),fcol=fest&&fest.closest('.obg-gl-col');
    if(fcol)cols.replaceChild(col,fcol);
    else{var nat=cols.querySelector('[data-gl-all="nature"]'),ncol=nat&&nat.closest('.obg-gl-col');cols.insertBefore(col,ncol||null)}
  }
  function seeAll(){
    freshView();
    /* Oct 20 2026: Family + Kids is a category now (falls back to the old Good for flag on older pages) */
    var box=document.querySelector('#obg input[name="obg-cat"][value="kids"]')||document.querySelector('#obg input[name="obg-good"][value="kids"]');
    if(box&&!box.checked){box.checked=true;box.dispatchEvent(new Event('change',{bubbles:true}))}
    var m=document.querySelector('#obg .obg-results-head');
    if(m)setTimeout(function(){window.scrollTo({top:m.getBoundingClientRect().top+window.scrollY-90,behavior:'smooth'})},60);
    try{if(typeof window.gtag==='function')window.gtag('event','guide_filter',{filter_type:'glance_family',filter_value:'kids',filter_on:'on'})}catch(_){}
  }

  /* ---------- 13. More glance categories (Oct 21 2026) ----------
   * Oct 21 2026 (later): the glance is four cards: Live Music, Comedy, Markets + Festivals and Nature.
   * The Family card (build(), section 2) is switched off in soon() and Sports/Festivals cards are removed.
   * Markets + Festivals is picked the same way as Family (OB Picks, then High priority, then soonest;
   * the area in view; next 7 days). Each card's arrow opens that category with every upcoming date.
   * Cards are put in one fixed order. On desktop they sit in rows of four (no tabs needed);
   * phones keep the swipe row with category tabs. Undo: remove moreCols() from soon(). */
  function sv(d){return '<svg class="obg-i" viewBox="0 0 24 24" aria-hidden="true">'+d+'</svg>'}
  var XCATS=[
    ['markfest','Markets + Festivals',/market|festival/i,sv('<path d="M3 20h18M5 20V10l7-6 7 6v10"/><path d="M10 20v-5h4v5"/>'),'market,fest']
  ];
  var ORDER=['music','comedy','markfest','nature'];
  function colKey(c){
    if(c.hasAttribute('data-obfam'))return'family';
    if(c.getAttribute('data-obcat'))return c.getAttribute('data-obcat');
    var b=c.querySelector('[data-gl-all]');return b?b.getAttribute('data-gl-all'):'';
  }
  function moreCols(){
    var cols=document.querySelector('#obg .obg-glance .obg-gl-cols');if(!cols)return;
    var st=null;try{st=window.OB_GUIDE_V3&&window.OB_GUIDE_V3.state()}catch(_){}
    var memo=(st?st.region:'')+'|'+dayKey(Date.now());
    if(moreCols.memo!==memo){moreCols.memo=memo;moreCols.cache={}}
    XCATS.forEach(function(x){
      if(cols.querySelector('[data-obcat="'+x[0]+'"]'))return;
      var p=moreCols.cache[x[0]];
      if(!p){p=moreCols.cache[x[0]]=picks(function(r){return x[2].test(String(r.cat||''))&&!/bingo/i.test(String(r.title||''))})}
      if(!p.list.length)return;
      var col=document.createElement('div');col.className='obg-gl-col';col.setAttribute('data-obcat',x[0]);
      col.innerHTML='<div class="obg-gl-colhead"><h3>'+x[3]+esc(x[1])+'</h3><button type="button" class="obg-sec-all" data-obcat-all="'+x[4]+'" aria-label="See all upcoming '+esc(x[1].toLowerCase())+'">See all →</button></div>'+
        p.list.map(function(y){
          var r=y.r,tag=r.url?'a':'div',attrs=r.url?' href="'+esc(tracked(r.url))+'" target="_blank" rel="noopener"':'';
          return '<'+tag+' class="obg-gl-item"'+attrs+'><span class="obg-gl-when">'+esc(when(y,p.today))+'</span><span class="obg-gl-title">'+(y.pick?'<span class="obg-r4-star" role="img" aria-label="OB Pick">★</span> ':'')+esc(r.title)+'</span><span class="obg-gl-venue">'+esc(r.place||r.hood||'')+'</span></'+tag+'>';
        }).join('');
      cols.appendChild(col);
    });
    /* Oct 21 2026: only Live Music, Comedy, Markets + Festivals and Nature; any other card is removed */
    Array.prototype.slice.call(cols.children).forEach(function(c){if(c.classList.contains('obg-gl-col')&&ORDER.indexOf(colKey(c))<0)cols.removeChild(c)});
    /* put every card in the fixed order (only moves what's out of place, so this settles after one pass) */
    var list=Array.prototype.slice.call(cols.children).filter(function(c){return c.classList.contains('obg-gl-col')});
    var want=list.slice().sort(function(a,b){var i=ORDER.indexOf(colKey(a)),j=ORDER.indexOf(colKey(b));return (i<0?99:i)-(j<0?99:j)});
    if(want.some(function(c,i){return c!==list[i]}))want.forEach(function(c){cols.appendChild(c)});
  }
  function seeCat(key){
    freshView();
    String(key).split(',').forEach(function(k){
      var box=document.querySelector('#obg input[name="obg-cat"][value="'+k+'"]');
      if(box&&!box.checked){box.checked=true;box.dispatchEvent(new Event('change',{bubbles:true}))}
    });
    var r=document.querySelector('#obg input[name="obg-when"][value="all"]');if(r&&!r.checked){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}
    var m=document.querySelector('#obg .obg-results-head');
    if(m)setTimeout(function(){window.scrollTo({top:m.getBoundingClientRect().top+window.scrollY-90,behavior:'smooth'})},60);
    try{if(typeof window.gtag==='function')window.gtag('event','guide_filter',{filter_type:'glance_more',filter_value:key,filter_on:'on'})}catch(_){}
  }
  var tmr;
  function soon(){clearTimeout(tmr);tmr=setTimeout(function(){addWeekPill();addWeekCard();wkRow();emptyHelp();moreCols();glanceCards();glanceTabs();onePicker();heroMarkets();weeklyTop();fixPreviewLinks()},30)}
  function start(){
    var root=document.getElementById('obg');if(!root)return;
    bindPills(root);setTimeout(syncPills,400);window.addEventListener('load',function(){setTimeout(syncPills,300)});
    if(window.MutationObserver)new MutationObserver(soon).observe(root,{childList:true,subtree:true});
    root.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-obfam-all]');if(b){e.preventDefault();e.stopPropagation();seeAll();return}var fc=e.target.closest&&e.target.closest('[data-obn-cal]');if(fc){e.preventDefault();e.stopPropagation();var vb=document.querySelector('#obg [data-view="calendar"]');if(vb&&vb.getAttribute('aria-pressed')!=='true')vb.click();var m=document.querySelector('#obg .obg-results-head');if(m)setTimeout(function(){window.scrollTo({top:m.getBoundingClientRect().top+window.scrollY-90,behavior:'smooth'})},80);return}var c=e.target.closest&&e.target.closest('[data-obcat-all]');if(c){e.preventDefault();e.stopPropagation();seeCat(c.getAttribute('data-obcat-all'))}},true);
    soon();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  window.addEventListener('load',soon);
})();
